import i18n from '@baidu/bce-i18n';

export async function initI18n(framework: any) {
    const language = framework.locale;
    const url = location.host.includes('bce.baidu')
        ? 'https://bce.bdstatic.com/console/static/i18n/console.%s.json'
        : 'https://bce.bdstatic.com/console/static/i18n/console.offline.%s.json';
    i18n.init({url});
    const result = await i18n.activate(language).catch(() => null);
    return result;
}

